var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:{ downOnPrevious: _vm.isNegative, upOnPrevious: _vm.isPositive }},[_vm._v(_vm._s(_vm.percentage)+"%")])}
var staticRenderFns = []

export { render, staticRenderFns }